module.exports = __webpack_public_path__ + "static/media/qr.ed9d004a.png";